import React from "react";
//import InfiniteCarousel from "react-leaf-carousel";
import "../assets/css/BrandImages.css";
import alpha from "../assets/Boiler-brands/alpha.png";
import ariston from "../assets/Boiler-brands/ariston.png";
import bosch from "../assets/Boiler-brands/bosch.png";
import glowworm from "../assets/Boiler-brands/glowworm.png";
import greenstar from "../assets/Boiler-brands/greenstar.png";
import ideal from "../assets/Boiler-brands/ideal.png";
import vaillant from "../assets/Boiler-brands/vaillant.png";
import viessman from "../assets/Boiler-brands/viessman.png";
import vokera from "../assets/Boiler-brands/vokera.png";
import worcester from "../assets/Boiler-brands/worcester.png";
import { Row, Col } from "react-bootstrap";

export const Brands = () => (

<div class="">
  <Row>
    <Col>
  <h2 className="heading-color text-center">Commmercial equipment brands we work with</h2>
    </Col>
  </Row>

  <br></br>
  <div className="image-slider">
  <div className="">
    <a href="https://www.alpha-innovation.co.uk" target="_blank" rel="noopener">
      <img alt="Alpha Heating Solutions logo" src={alpha} />
    </a>
  </div>
  <div>
    <a href="https://www.ariston.com/uk/" target="_blank" rel="noopener">
      <img alt="Ariston UK boiler brand logo" src={ariston} />
    </a>
  </div>
  <div>
    <a href="https://www.bosch-thermotechnology.com/gb/en/" target="_blank" rel="noopener">
      <img alt="Bosch Thermotechnology logo" src={bosch} />
    </a>
  </div>
  <div>
    <a href="https://www.glow-worm.co.uk" target="_blank" rel="noopener">
      <img alt="Glow-worm boilers logo" src={glowworm} />
    </a>
  </div>
  <div>
    <a href="https://www.worcester-bosch.co.uk/products" target="_blank" rel="noopener">
      <img alt="Worcester Bosch Greenstar logo" src={greenstar} />
    </a>
  </div>
  <div>
    <a href="https://idealheating.com" target="_blank" rel="noopener">
      <img alt="Ideal Heating company logo" src={ideal} />
    </a>
  </div>
  <div>
    <a href="https://www.vaillant.co.uk" target="_blank" rel="noopener">
      <img alt="Vaillant UK boiler brand logo" src={vaillant} />
    </a>
  </div>
  <div>
    <a href="https://www.viessmann.co.uk" target="_blank" rel="noopener">
      <img alt="Viessmann boiler systems logo" src={viessman} />
    </a>
  </div>
  <div>
    <a href="https://www.vokera.co.uk" target="_blank" rel="noopener">
      <img alt="Vokera heating solutions logo" src={vokera} />
    </a>
  </div>
  <div>
    <a href="https://www.worcester-bosch.co.uk" target="_blank" rel="noopener">
      <img alt="Worcester Bosch main logo" src={worcester} />
    </a>
  </div>
</div>
</div>
);
